/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var QreBotElement = new Class({
  Extends: QuriobotElement,
  template: function () {
    var base =
      '<div class="bot--bubble chat-text isLoading" family="{{ key }}" id="{{ eid }}">' +
      '     <div class="bot--avatar"></div>' +
      '     <div class="bot--body">' +
      '         <div class="bot--loading">' +
      '             <div class="loading--dots">' +
      '                 <div class="dot dot--a"></div>' +
      '                 <div class="dot dot--b"></div>' +
      '                 <div class="dot dot--c"></div>' +
      '             </div>' +
      '         </div>' +
      '         <div class="bot--text">' +
      '             {{ str }}' +
      '         </div>' +
      '     </div>' +
      ' </div>'

    var info =
      '<div class="panel--wrapper chat-text bot--info isLoading" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="panel--main">' +
      '        <div class="panel--icon">' +
      '            <span>i</span>' +
      '        </div>' +
      '        <div class="panel--content">' +
      '            {{ content }}' +
      '        </div>' +
      '    </div>' +
      '</div>'

    var link =
      '<div class="panel--wrapper chat-text bot--info bot--link isLoading" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="panel--main">' +
      '        <div class="panel--icon {{ extend_class }}">' +
      '            <span></span>' +
      '        </div>' +
      '        <a href="{{ href }}" target="{{ target }}" rel="noopener noreferrer" class="panel--content">' +
      '            {{ str }}' +
      '        </a>' +
      '    </div>' +
      '</div>'

    var html =
      '<div class="panel--wrapper chat-text bot--html {{ extend_class }} isLoading" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="panel--main">' +
      '        {{ content }}' +
      '    </div>' +
      '</div>'

    var pixel =
      '<div class="panel--wrapper chat-text bot--html {{ extend_class }} isLoading hidden" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="panel--main">' +
      '        {{ content }}' +
      '    </div>' +
      '</div>'

    var image =
      '<div class="panel--wrapper chat-text bot--image isLoading" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="panel--main">' +
      '        <div class="bot-image">' +
      '            <img title="{{ str }}" alt="{{ str }}" src="{{ src }}" width="100%" />' +
      '            <div class="bot-image__controls">' +
      (this.data.str.href !== '#'
        ? '                <a class="bot-image__control" href="{{ href }}" rel="noopener noreferrer" target="{{ target }}"><span class="icon__link"></span></a>'
        : '') +
      '                <div id="modalOpener{{ eid }}" class="modal__opener-image bot-image__control"><span class="icon__search"></span></div>' +
      '                <div id="modalContent{{ eid }}" class="modal__content">' +
      '                </div>' +
      '            </div>' +
      '        </div>' +
      '    </div>' +
      '</div>'

    var video =
      '<div class="panel--wrapper chat-text bot--video {{ extend_class }} isLoading" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="panel--main">' +
      '        {{ content }}' +
      '    </div>' +
      '</div>'

    var audio_file =
      '<div class="panel--wrapper chat-text bot--audio {{ extend_class }} isLoading" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="panel--main">' +
      '        <audio src="{{ src }}" preload="auto" playsinline {{ autoplay }} {{ controls }} {{ loop }} {{ muted }} title="{{ str }}" />' +
      '    </div>' +
      '</div>'

    var video_file =
      '<div class="panel--wrapper chat-text bot--video {{ extend_class }} isLoading" family="{{ key }}" id="{{ eid }}">' +
      '    <div class="panel--main">' +
      '        <video src="{{ src }}" preload="auto" playsinline {{ autoplay }} {{ controls }} {{ loop }} {{ muted }} title="{{ str }}" />' +
      '    </div>' +
      '</div>'

    return {
      base: base,
      info: info,
      link: link,
      file: link,
      audio_file: audio_file,
      video_file: video_file,
      html: html,
      image: image,
      video: video,
      embed: video,
      pixel: pixel,
    }
  },
  attach: function () {
    var modalOpener = document.getElementById('modalOpener' + this.data.eid),
      modalContent = document.getElementById('modalContent' + this.data.eid)
    var el = $(this.data.eid)

    if (modalOpener) {
      var content = el.getElements('.bot-image img').getLast()
      if (content && content.outerHTML) {
        modalOpener.addEventListener('click', function () {
          modal.setContent(content.outerHTML)
          modal.open()
        })
      }
    }
    if (el) {
      el.getElements('noscript').forEach(function (e) {
        var d = document.createElement('div')
        d.innerHTML = e.innerHTML
        e.parentNode.replaceChild(d, e)
      })
      el.getElements('script').forEach(function (e) {
        window.postscribe(e.parentNode, e.outerHTML)
        e.parentNode.removeChild(e)
      })
      el.getElements('a').forEach(
        function (e) {
          this.quriobot.populateURL(e.getAttribute('href'), function (url) {
            e.setAttribute('href', url)
          })
        }.bind(this)
      )
      // pause other videos and audios
      if (el.getElements('video, audio').getLast()) {
        this.parent
          .getElements(
            ':not([id=' + this.data.eid + ']) .panel--main audio, :not([id=' + this.data.eid + ']) .panel--main video'
          )
          .forEach(function (item) {
            item.pause()
          })
      }
    }
  },
})
